import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '../../constants';
import { GATrackingEventOptions } from '../ga-tracking-event-options.model';
import { ApplicationAuthorizationActionType as AuthType } from '~shared/modules/application-event/constants';

export class GaTrackingAuthorizationEvent implements GATrackingEvent {
  constructor(
    private event: string,
    private category: string,
    private action?: AuthType,
    private label?: string,
    private horecaTag?: string,
    private loginType?: string,
    private tenant?: string
  ) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.Authorization;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.event,
      category: this.category,
      label: this.label,
      gtmCustom: {
        action: this.action,
        category: this.category,
        ...(this.horecaTag !== undefined ? { horecaTag: this.horecaTag } : {}),
        ...(this.loginType !== undefined ? { loginType: this.loginType } : {}),
        ...(this.tenant !== undefined ? { tenant: this.tenant } : {}),
      },
    };
  }

  getOptions(): GATrackingEventOptions {
    return {
      sendCustomerType: [AuthType.LoggedIn, AuthType.Registered].includes(this.action),
    };
  }
}
